var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ProfileOptionSelector',{attrs:{"model":'jobCategory',"univKeys":Number(1),"nextRoute":() => 'OnboardSchool'}})
}
var staticRenderFns = []

export { render, staticRenderFns }